import type { Dispatch } from "react";
import { useReducer } from "react";
import type {
  OptionsNavigatorAction,
  OptionsNavigatorState,
} from "./optionsNavigatorReducer";
import optionsNavigatorReducer from "./optionsNavigatorReducer";

export default function useOptionsNavigatorReducer(): [
  OptionsNavigatorState,
  Dispatch<OptionsNavigatorAction>,
] {
  return useReducer(optionsNavigatorReducer, {
    query: "",
    isEditMode: false,
    selectedIndex: null,
  });
}
